import { render, staticRenderFns } from "./Forspeed.vue?vue&type=template&id=2460c8c3&scoped=true"
import script from "./Forspeed.vue?vue&type=script&lang=js"
export * from "./Forspeed.vue?vue&type=script&lang=js"
import style0 from "./Forspeed.vue?vue&type=style&index=0&id=2460c8c3&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460c8c3",
  null
  
)

export default component.exports